"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var theme_1 = require("../../theme");
var Typography_1 = require("../Typography");
var ListCardItem = function (_a) {
    var _b, _c, _d, _e;
    var id = _a.id, title = _a.title, titleClassName = _a.titleClassName, subTitle = _a.subTitle, subTitleClassName = _a.subTitleClassName, containerClassName = _a.containerClassName, ariaLabel = _a.ariaLabel, dataTestId = _a["data-testid"], onClick = _a.onClick, hasSeparator = _a.hasSeparator;
    var borderColors = (0, theme_1.useBorderColors)();
    var handleClick = (0, react_1.useCallback)(function () {
        onClick === null || onClick === void 0 ? void 0 : onClick(id);
    }, []);
    var clickable = !!onClick;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ id: id, "data-testid": dataTestId, onClick: handleClick, className: (0, classnames_1.default)('squid-flex', 'squid-items-center', 'squid-px-alias-list-padding-tighter', 'squid-w-full', 'squid-gap-5', containerClassName, (_b = {},
            _b['hover:squid-rounded-xl'] = clickable,
            _b['hover:squid-bg-alias-state-base-active'] = clickable,
            _b['squid-cursor-pointer'] = clickable,
            _b['squid-border-b'] = hasSeparator,
            _b[borderColors.weak] = hasSeparator,
            _b)), "aria-label": ariaLabel, tabIndex: 0, role: "button", "aria-disabled": !clickable }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)('squid-flex squid-flex-col', 'squid-py-alias-list-padding-tighter', 'squid-gap-2', (_c = {},
                _c['squid-cursor-pointer'] = clickable,
                _c)) }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "h5", size: "lg", color: "weaker", strong: true, className: (0, classnames_1.default)(titleClassName, (_d = {},
                        _d['squid-cursor-pointer'] = clickable,
                        _d)) }, { children: title })), !!subTitle && ((0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "h6", size: "base", color: "weakest", strong: false, className: (0, classnames_1.default)(subTitleClassName, (_e = {},
                        _e['squid-cursor-pointer'] = clickable,
                        _e)) }, { children: subTitle })))] })) }), id));
};
exports.default = ListCardItem;
